<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refresh"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refresh"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索教师姓名"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-button size="small" type="primary" @click="onReset">重置</el-button>
        <div class="space"></div>
        <el-button
          v-if="userInfo.roleCodes.includes('researchGroupLeader')"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          >创建带教</el-button
        >
      </div>
    </el-form>
    <el-table :data="tableData" style="width: 100%; margin-top: 20px">
      <el-table-column
        prop="schoolYear"
        label="学年"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="schoolTerm"
        label="学期"
        width="100"
        align="center"
        :formatter="termFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="teachedName"
        label="新教师姓名"
        align="center"
      ></el-table-column>
      <el-table-column prop="userDutyDesc" label="学历">
        <template slot-scope="scope">
          {{ scope.row.teacherArchivesDTO?.educationDesc }}
        </template>
      </el-table-column>
      <el-table-column prop="teachingAge" label="教龄">
        <template slot-scope="scope">
          {{ scope.row.teacherArchivesDTO?.teachingAge }}
        </template>
      </el-table-column>

      <el-table-column prop="className" label="任课班级">
        <template slot-scope="scope">
          {{ scope.row.teacherArchivesDTO?.className }}</template
        >
      </el-table-column>
      <el-table-column prop="remark" label="特长">
        <template slot-scope="scope">
          {{
            scope.row.teacherArchivesDTO?.remark &&
            JSON.parse(scope.row.teacherArchivesDTO.remark)?.speciality
          }}</template
        >
      </el-table-column>
      <el-table-column
        prop="teacherName"
        label="带教师傅"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            :disabled="
              userInfo.userId != scope.row.createBy &&
              !userInfo.roleCodes.includes('admin')
            "
            @click="onEdit(scope.row)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              :disabled="
                userInfo.userId != scope.row.createBy &&
                !userInfo.roleCodes.includes('admin')
              "
              slot="reference"
              type="text"
              class="danger"
              size="small"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="filterForm"
      ></pagination>
    </el-table>
    <el-dialog
      :title="newTaskForm.id == null ? '新增带教' : '编辑带教'"
      :visible.sync="dialogNewTask"
      @closed="onDialogNewTaskClose"
    >
      <el-form
        v-loading="saving"
        class="content-box"
        label-width="140px"
        ref="elNewTaskForm"
        :model="newTaskForm"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolYear" label="学年">
              <school-year-selector
                v-model="newTaskForm.schoolYear"
                @change="schoolYearChange"
              ></school-year-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolTerm" label="学期">
              <school-term-selector
                v-model="newTaskForm.schoolTerm"
                @change="schoolYearChange"
                :checkAll="false"
              ></school-term-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="新教师姓名" prop="teachedTemp">
          <el-select
            size="small"
            value-key="teacherId"
            filterable
            v-model="newTaskForm.teachedTemp"
            :filter-method="filterMethod2"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in userOptions2"
              :key="item.userId"
              :label="item.userName"
              :value="{
                teacherId: item.userId,
                teacherName: item.userName,
              }"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="带教师傅" prop="teacherTemp">
          <el-select
            size="small"
            value-key="teacherId"
            filterable
            v-model="newTaskForm.teacherTemp"
            :filter-method="filterMethod"
            placeholder="请选择"
            clearable
            @visible-change="visibleChange"
          >
            <el-option
              v-for="item in userOptions2"
              :key="item.userId"
              :label="item.userName"
              :value="{
                teacherId: item.userId,
                teacherName: item.userName,
              }"
            ></el-option></el-select
        ></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogNewTask = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DicSelector from "../../components/school/dicSelector.vue";
import SchoolTermSelector from "../../components/school/schoolTermSelector.vue";
import AuthorSelector from "@/components/school/authorSelector.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "../../http/fetch.js";
import Pagination from "../../components/Pagination.vue";
import { power } from "@/utils/index.js";
const taskForm = {
  id: null,
  teachingCode: null,
  operatorId: null,
  schoolCode: null,
  schoolYear: null,
  schoolTerm: null,
  teacherTemp: null,
  teachedTemp: null,
};
export default {
  components: {
    schoolYearSelector,
    SchoolTermSelector,
    DicSelector,
    Pagination,
    AuthorSelector,
  },
  name: "teachingTask",
  data() {
    return {
      loading: false,
      pageLoading: false,
      saving: false,
      tableData: [],
      disciplineOptions: [],
      userOptions: [],
      userOptions2: [],
      newTaskForm: taskForm,
      dialogNewTask: false,
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: null,
        size: 10,
        current: 1,
        total: 0,
      },
      rules: {
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        schoolTerm: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        teacherTemp: [
          { required: true, message: "请选择带教人", trigger: "change" },
        ],
        teachedTemp: [
          { required: true, message: "请选择被带教人", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode", "operatorId", "schoolCodes"]),
  },
  mounted() {
    this.getData();
  },
  created() {
    this.getTeacherInfoList2();
  },
  methods: {
    termFormatter(row, column, cellValue, index) {
      let result = cellValue == 1 ? "上学期" : "下学期";
      return result;
    },
    onAdd() {
      this.userOptions = [];
      this.newTaskForm = taskForm;
      this.dialogNewTask = true;
      // if (this.userInfo.roleCodes == "teacher") {
      //   this.newTaskForm.teacherTemp = {
      //     userId: this.userInfo.userId,
      //     userName: this.userInfo.userName,
      //   };
      // }
    },
    onReset() {
      this.filterForm.schoolYear = null;
      this.filterForm.schoolTerm = null;
      this.filterForm.keyword = null;
      this.refresh();
    },
    schoolYearChange() {
      this.newTaskForm.teacherTemp = null;
    },
    power,
    onDialogNewTaskClose() {
      this.$refs.elNewTaskForm.resetFields();
    },
    refresh() {
      this.filterForm.pageNum = 1;
      this.getData();
    },
    onDel(row) {
      this.saving = true;
      postJson("/researchGroup/deleteTeacherTaskInfo", {
        operatorId: this.userInfo.userId,
        id: row.id,
      })
        .then((res) => {
          this.getData();
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
    getData() {
      this.loading = true;
      postJson("/researchGroup/getTeacherTaskInfoList", {
        schoolCodes: this.schoolCodes,
        schoolCode: this.schoolCode,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        checkStatus: 1,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        keyword: this.filterForm.keyword,
        operatorId: this.operatorId,
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getTeacherInfoList(query = "") {
      return new Promise((resove, reject) => {
        postData("/researchGroup/getGroupTeachersByLeader", {
          leaderId: this.userInfo.userId,
          schoolCode: this.schoolCode,
          schoolYear: this.newTaskForm.schoolYear,
          schoolTerm: this.newTaskForm.schoolTerm,
          keyword: query,
        }).then((res) => {
          if (res.length) {
            this.userOptions = res;
            resove(res);
          } else {
            this.userOptions = [];
            reject();
          }
        });
      });
    },
    async getTeacherInfoList2(query = "") {
      return new Promise((resove, reject) => {
        postJson("/user/getTeacherInfoList", {
          schoolCodes: this.schoolCodes ? this.schoolCodes : [this.schoolCode],
          keyword: query,
        }).then((res) => {
          if (res.records.length) {
            this.userOptions2 = res.records;
            resove(res);
          } else {
            this.userOptions2 = [];
            reject();
          }
        });
      });
    },
    async filterMethod2(query) {
      if (this.userOptions2.length == 0) {
        await this.getTeacherInfoList2();
      } else {
        await this.getTeacherInfoList2(query);
      }
    },
    async filterMethod(query) {
      if (this.userOptions.length == 0) {
        await this.getTeacherInfoList();
      } else {
        await this.getTeacherInfoList(query);
      }
    },
    visibleChange(bool) {
      if (bool) {
        if (!this.newTaskForm.schoolYear) {
          this.$message({ message: "请选择学年", type: "warning" });
          return;
        }
        if (!this.newTaskForm.schoolTerm) {
          this.$message({ message: "请选择学期", type: "warning" });
          return;
        }
        this.filterMethod("");
      }
    },
    onEdit(row) {
      this.newTaskForm = {
        id: row.id,
        teachingCode: row.teachingCode,
        schoolYear: row.schoolYear,
        schoolTerm: row.schoolTerm,
        teacherTemp: {
          teacherId: row.teacherId,
          teacherName: row.teacherName,
        },
        teachedTemp: {
          teacherId: row.teachedId,
          teacherName: row.teachedName,
        },
      };
      this.visibleChange(true);
      this.dialogNewTask = true;
    },
    onSave() {
      this.$refs.elNewTaskForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          postJson("/researchGroup/saveOrUpdateTeacherTaskInfo", {
            id: this.newTaskForm.id ? this.newTaskForm.id : null,
            teachingCode: this.newTaskForm.teachingCode
              ? this.newTaskForm.teachingCode
              : null,
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            schoolYear: this.newTaskForm.schoolYear,
            schoolTerm: this.newTaskForm.schoolTerm,
            teachedId: this.newTaskForm.teachedTemp.teacherId,
            teachedName: this.newTaskForm.teachedTemp.teacherName,
            teacherId: this.newTaskForm.teacherTemp.teacherId,
            teacherName: this.newTaskForm.teacherTemp.teacherName,
          })
            .then((res) => {
              this.dialogNewTask = false;
              this.$message.success("操作成功！");
              this.filterForm.pageNum = 1;
              this.getData();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" >
.authorSelector {
  margin-left: 0 !important;
}
</style>
